<template>
    <div class="reg-temp-content-area p-3 main-content-height">
        <router-link class="btn btn-primary mb-3 px-4" :to="{name: 'ResellerCustomersAdd'}">
            <i class="fa fa-plus"></i> Add New Customer
        </router-link>

        <div class="row">
            <div class="col-sm-12 col-md-12 mb-2">
                <div class="row justify-content-between">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <input class="search-input top-search-input" v-model="s" placeholder="Search by Email / Name" />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <pagination class="mt-0" :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-12" v-if="customers.length == 0 && mountLoadingCount > 0">
                <p class="text-center mt-5">No customer found.</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-3" v-bind:key="'customer_' + index" v-for="(customer, index) in customers">
                <customer-item :editcallback="editCallBack" :deletecallback="deleteCallBack" :user="customer" />
            </div>
        </div>

        <pagination :pagenavs="pageNavs" :currentpage="currentPage" :callback="fetchPage"></pagination>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import Pagination from '@/components/Pagination';

export default {
    name: 'resellerCustomerPage',
    components: {
        Pagination
    },
    data() {
        return {
            s: '',
            currentPage: 1,
            pageNavs: [],
            customers: [],
            mountLoadingCount: 0
        };
    },
    computed: {
        ...mapGetters({
            vg_user_id: 'auth/userid'
        })
    },

    watch: {
        s(val) {
            this.currentPage = 1;
            this.fetchCustomer();
        }
    },

    mounted() {
        this.fetchCustomer();
    },

    methods: {
        /**
         * Fetch reg products
         */
        fetchCustomer: _.debounce(function () {
            this.loading = true;
            const url = `${Env.baseUrl}/reseller/customers/list?page=${this.currentPage}&s=${this.s}`;
            AuthApis.getApi(url)
                .then((res) => {
                    this.mountLoadingCount = 1;
                    this.customers = res.data.payload;
                    this.pageNavs = res.data.nav;
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = true;
                });
        }, 500),

        /**
         * Fetch page data
         */
        fetchPage(pageNo) {
            this.currentPage = pageNo;
            this.fetchCustomer();
        },

        deleteCallBack(obj) {
            this.$confirm({
                title: `DELETE?`,
                message: 'Are you sure you want to delete ' + obj.email,
                button: {
                    no: 'No',
                    yes: 'Yes'
                },
                callback: (confirm) => {
                    if (confirm) {
                        const url = `${Env.baseUrl}/reseller/customers/delete/${obj.id}`;
                        AuthApis.deleteApi(url)
                            .then(async (res) => {
                                this.fetchCustomer();
                                this.$toasted.global.success({
                                    message: 'Successfully deleted.'
                                });
                            })
                            .catch((err) => {
                                this.$toasted.global.error({
                                    message: 'Failed, please try again later.'
                                });
                            });
                    }
                }
            });
        },

        editCallBack(user) {
            return this.$router.push({
                name: 'ResellerCustomerEdit',
                params: {
                    customer_id: user.id
                }
            });
        },

        ...mapActions({})
    }
};
</script>
